var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"nutritional-info"},[(_vm.property !== 'em')?_c('vue-numeric',{attrs:{"precision":0,"read-only":true,"value":_vm.value}}):_c('vue-numeric',{attrs:{"precision":1,"read-only":true,"value":Math.round(_vm.value*10)/10,"separator":"."}}),_vm._v(" "),(_vm.property !== 'em')?_c('span',[_vm._v("%")]):_c('span',[_vm._v("Mcal")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }